<template>
  <div id="app">
    <v-app v-cloak id="inspire">
      <v-layout>
        <v-flex fill-height>
          <v-content class="main-content">
            <v-toolbar height="120"
                       color="white"
                       style="z-index: 10;"
                       app
                       class="mx-0 px-0">
              <v-card flat color="white">
                <span class="hidden-xs-only pl-2">&nbsp;</span>
                <img alt="OEL Header Image" class="oelHeaderImage" src="~assets/images/DEL-full-color-logo.png" style="max-height: 100px; max-width: 90vw;">
                <span class="hidden-xs-only pr-2">&nbsp;</span>
              </v-card>
              <v-spacer />
              <v-card flat class="hidden-xs-only" color="white" style="max-width: calc(100vw - 400px); text-align: center">
                <v-btn small href="http://www.floridaearlylearning.com/" flat color="blue darken-2" class="mx-0" target="_blank">
                  <nt-icon>launch</nt-icon><span style="text-transform:none; padding-left: 10px">Division of Early Learning Website</span>
                </v-btn>
              </v-card>
            </v-toolbar>
            <div class="img-container">
              <v-container>
                <v-flex lg7 md9 sm10 class="smoke-box">
                  <br />
                  <h1>Site Maintenance</h1>
                  <p>
                    The Voluntary Prekindergarten (VPK) Provider Kindergarten Readiness Rate website is currently down for a bit of maintenance, but we'll be back soon.
                  </p>
                </v-flex>
              </v-container>
            </div>
          </v-content>
        </v-flex>
      </v-layout>
    </v-app>
  </div>
</template>

<script>
  export default {
    mounted() {
      window.scrollTo(0, 0);
    }
  }
</script>

<style scoped>
  .smoke-box {
    background-color: rgba(0,0,0,0.3);
    padding: 8px 12px;
  }
  .img-container {
    background-image: url('~assets/images/landing-page-rocket-80.jpg');
    background-position-x: center;
    background-position-y: 50%;
    min-height: calc(100vh - 120px);
  }
  h1 {
    margin-bottom: 12px;
    font-weight: 400;
  }
  p {
    font-size: 110%;
  }
  h1, h2, p {
    color: white;
  }
</style>
